<script>
export default {
  props: {
    showLogo: {
      type: Boolean,
      default: true
    },
    logoName: {
      type: String,
      default: "icons_12pt_right.png"
    },
    showSeparator: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    maxlength: {
      type: [Number],
      default: 50
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    errTips: {
      type: String,
      default: ''
    },
    valueStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    }
  }
}

</script>

<template>
<div class="hs-section-cell" :class="{border: showSeparator, err: errTips}">
  <div class="label" v-if="title">{{title}}</div>
  <slot>
    <input v-if="type === 'input'" class="text" v-model.trim="currentValue" :maxlength='maxlength' :placeholder="placeholder">
    <div v-else class="text" :style="valueStyle" :class="{gray: !value}">{{value || placeholder}}</div>
  </slot>
  <div v-if="clearable && currentValue" class="logo clear" @click.stop="$emit('clear')" :style="{backgroundImage: `url(${require('@/assets/image/base/close/icons_24pt_close.svg')})`}"></div>
  <div v-if="showLogo" class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/' + logoName)})`}"></div>
  <span v-if="errTips" class="tips">{{errTips}}</span>
</div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-section-cell{
  @extend .flex-start;
  @extend .hs-font-body;
  width: 100%;
  min-height: 56px;
  padding: 8px 0;
  word-break: break-all;
  >.label{
    flex-shrink: 0;
    color: $color_black_300;
    width: 60px;
    margin-right: 24px;
  }
  >.text{
    width: 100%;
    font-weight: 500;
    padding: 0;
    &::placeholder{
      color: $color_black_50;
    }
  }
  >.gray{
    color: $color_black_50;
    font-weight: 400;
  }
  >.logo{
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    margin-left: 4px;
    background-size: 100% 100%;
  }
  >.clear{
    width: 24px;
    height: 24px;
  }
  &.err{
    position: relative;
    // box-shadow: 0px -0.5px 0px 0px rgba(245, 54, 28, 1) inset;
    border-bottom: 0.5px solid rgba(245, 54, 28, 1);
    &:last-child{
      // box-shadow: 0px -0.5px 0px 0px rgba(245, 54, 28, 1) inset;
      border-bottom: 0.5px solid rgba(245, 54, 28, 1);
    }
    >.tips{
      @extend .hs-font-caption-3;
      position: absolute;
      bottom: 4px;
      left: 0;
      transform: scale(0.83);
      transform-origin: left;
      color: $color_red_300;
      margin-left: 84px;
    }
  }
}
.border{
  // box-shadow: 0px -0.5px 0px 0px #EEEDED inset;
  border-bottom: 0.5px solid #EEEDED;
  &:last-child{
    border-bottom: none;
  }
}
</style>
